import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';

export const timesheetGuard = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (!auth.isLoggedIn) {
    router.navigate(['/login']);
    return false;
  }

  const role = (auth.role || '').toLowerCase();
  if (role === 'employee' || role === 'manager' || role === 'admin') {
    return true;
  }

  router.navigate(['/public-schedule']);
  return false;
};
